import React, { Suspense } from 'react';
import { useHierarchyContext } from '../../../hooks/useHierarchyContext';
const RecItems = React.lazy(async () => await import('./RecommendedItems.component').then(({ RecommendedItemsComponent }) => ({ default: RecommendedItemsComponent })));
export const RecommendedItems = () => {
    const { supRecommendedItemsData } = useHierarchyContext();
    if (supRecommendedItemsData === undefined)
        return null;
    return (React.createElement(Suspense, null,
        React.createElement(RecItems, null)));
};
